import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadService 
{
  private readonly HOST:string = environment.BASE_URL

  constructor
  (
    private httpClient:HttpClient,
    private sharedService: SharedService
  ) { }

  checkDownloadable(ref:string[], subFolder:string):Observable<Document[]>
  {
    const url = `${this.HOST}/check-downloadable`
    return this.httpClient.get<Document[]>(url, 
    {
      params : 
      {
        ref,
        path:subFolder
      }
    })
  }


  downloadProcess(payload:{ref:string, fileName:string, type:string, path:string, id_service?:string, liste_pj?:string[], service?:string})
  {
    this.sharedService.blurPage()

    this.download(payload).subscribe((blob:Blob) => this.downloadBlob(blob, payload))
  }

  download(payload:{ref:string, fileName:string, type:string, path:string, id_service?:string, liste_pj?:string[]}): Observable<Blob>
  {
    const url = `${this.HOST}/download`

    return this.httpClient.get(url, 
      {
        params:
        {
          payload:JSON.stringify(payload)
        },
        responseType: 'blob'
      }
    )
  }

  downloadBlob(blob:Blob, payload:{ref:string, fileName:string, type:string, path:string, id_service?:string, liste_pj?:string[], service?:string})
  {
    if( blob?.size == 0 )
    {
      alert("fichier non trouvé")
      return this.sharedService.focusPage()
    }

    const blobUrl = URL.createObjectURL(blob)
    const link = document.createElement("a")


    link.href = blobUrl

    if(payload.type == "all_pj_message") 
    {
      link.download = payload.ref
    }
    else if(payload.type == "all_pj_message_partenariat") 
    {
      link.download = String(payload.service)
    }
    else if(payload.type == "dip_convention") 
    {
      link.download = payload.fileName.split("-")[0]
    }
    else
    {
      link.download = payload.fileName
    }
    link.click()
    window.URL.revokeObjectURL(link.toString())

    this.sharedService.focusPage()
  }
}
